import { render, staticRenderFns } from "./MergeReportSetting.vue?vue&type=template&id=38bbf0eb&scoped=true&"
import script from "./MergeReportSetting.vue?vue&type=script&lang=js&"
export * from "./MergeReportSetting.vue?vue&type=script&lang=js&"
import style0 from "./MergeReportSetting.vue?vue&type=style&index=0&id=38bbf0eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbf0eb",
  null
  
)

export default component.exports